import React from "react";
import { isMobile } from "react-device-detect";
import "./successPage.css";
export default function SuccessPage() {
  return (
    <>
      <div className="success-text">
        <div className="success-text-lines">
          <div
            className={
              isMobile
                ? "success-text-thanks success-text-thanks-mobile"
                : "success-text-thanks"
            }
            style={{ lineHeight: isMobile ? "48px" : "" }}
          >
            תודה רבה, הפרטים שלך נקלטו בהצלחה
          </div>
          <div className="success-text-contact">
            <div>אנו ניצור איתך קשר בימים הקרובים</div>
            <div>עומדים לרשותך בכל מצב</div>
            <div
              style={{
                direction: "ltr",
                textAlign: "right",
                marginBottom: "10px",
              }}
            >
              {" "}
              03-6460800 | sherut@cet.ac.il
            </div>
            <div>מטח, המרכז לטכנולוגיה חינוכית</div>
          </div>
        </div>
      </div>
    </>
  );
}
